import { useMutation } from "@apollo/client";

import {
  CREATE_OEM_RESOURCE_MUTATION,
  UPDATE_OEM_RESOURCE_MUTATION,
  DELETE_OEM_RESOURCE_MUTATION,
} from "~/api";
import { Resource } from "~/api/_fragments";
import { errorsHandler } from "~/transformers";

export const useCreateOemResource = () => {
  const [create, { loading, error }] = useMutation(
    CREATE_OEM_RESOURCE_MUTATION,
  );

  return {
    isCreating: loading,
    error,
    createResource: async (input) =>
      new Promise((resolve, reject) => {
        return create({
          variables: { input },
          update(cache, { data: { createOwnOemResource: ref } }) {
            cache.modify({
              fields: {
                listOwnOemResources(existingRefs = []) {
                  const newRef = cache.writeFragment({
                    data: ref,
                    fragment: Resource.fragments.ResourceListData,
                    fragmentName: "ResourceListData",
                  });

                  return {
                    ...existingRefs,
                    resources: [...existingRefs.resources, newRef],
                  };
                },
              },
            });
          },
        })
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(errorsHandler(err));
          });
      }),
  };
};

export const useUpdateOemResource = () => {
  const [updateOemResource, { loading, error }] = useMutation(
    UPDATE_OEM_RESOURCE_MUTATION,
  );

  return {
    isUpdating: loading,
    error,
    updateResource: async (input) =>
      new Promise((resolve, reject) => {
        return updateOemResource({
          variables: { input },
          update(cache, { data: { updateOwnOemResource: ref } }) {
            cache.modify({
              id: cache.identify({ __typename: "Resource", id: ref._id }),
              fields: {
                listOwnOemResources(existingRefs = []) {
                  const newRef = cache.writeFragment({
                    data: ref,
                    fragment: Resource.fragments.ResourceListData,
                    fragmentName: "ResourceListData",
                  });

                  return [...existingRefs, newRef];
                },
              },
            });
          },
        })
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(errorsHandler(err));
          });
      }),
  };
};

export const useDeleteOemResource = () => {
  const [deleteOemResource, { loading, error }] = useMutation(
    DELETE_OEM_RESOURCE_MUTATION,
  );

  return {
    isDeleting: loading,
    error,
    deleteResource: async (input) =>
      new Promise((resolve, reject) => {
        return deleteOemResource({
          variables: { input },
          update(cache) {
            cache.evict({
              id: "ROOT_QUERY",
              fieldName: "listOwnOemResources",
            });
          },
        })
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(errorsHandler(err));
          });
      }),
  };
};
